import React, { useEffect, useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { validateExternalIdRequiresArn } from "integrations/aws/utils/awsValidation";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { ApiRoutes } from "./Routes";
import AWSAuthenticationTypes, { AWS_AUTH_TYPES } from "../common/aws/AWSAuthenticationTypes";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const [regions, setRegions] = useState([]);
  useEffect(() => {
    fetch("GET", qualifyUrl(ApiRoutes.INTEGRATIONS.GenericS3.GET_AWS_REGIONS)).then((response) => {
      const region = Object.keys(response).map((key) => ({ label: response[key], value: key }));
      setRegions(region);
    });
  }, []);
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { awsSecretKey } = formData;
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const externalIdError = validateExternalIdRequiresArn(
      (_a = formData == null ? void 0 : formData.assumeRoleArn) == null ? void 0 : _a.value,
      (_b = formData == null ? void 0 : formData.awsExternalId) == null ? void 0 : _b.value
    );
    if (externalIdError) {
      setFormError({
        full_message: externalIdError,
        nice_message: externalIdError
      });
      return;
    }
    setLoading(true);
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.GenericS3.CHECK_CREDENTIALS), {
      aws_s3_access_key: ((_c = formData == null ? void 0 : formData.awsAccessKey) == null ? void 0 : _c.value) || "",
      aws_s3_secret: ((_d = formData == null ? void 0 : formData.awsSecretKey) == null ? void 0 : _d.value) || "",
      sqs_queue_name: ((_e = formData == null ? void 0 : formData.sqsQueueName) == null ? void 0 : _e.value) || "",
      aws_s3_region: ((_f = formData == null ? void 0 : formData.awsS3Region) == null ? void 0 : _f.value) || "",
      assume_role_arn: ((_g = formData == null ? void 0 : formData.assumeRoleArn) == null ? void 0 : _g.value) || "",
      aws_external_id: ((_h = formData == null ? void 0 : formData.awsExternalId) == null ? void 0 : _h.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to AWS using provided configuration."
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to AWS using provided configuration."
      });
    });
  };
  const authType = formData.awsAuthenticationType && formData.awsAuthenticationType.value;
  const isFormValid = formValidation.isFormValid(
    [
      "genericS3Name",
      ...authType !== AWS_AUTH_TYPES.automatic ? ["awsAccessKey", "awsSecretKey"] : [],
      "awsS3Region"
    ],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "genericS3Name",
        type: "text",
        fieldData: formData.genericS3Name,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: awsSecretKey == null ? void 0 : awsSecretKey.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(AWSAuthenticationTypes, { onChange }),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sqsQueueName",
        type: "text",
        onChange,
        fieldData: formData.sqsQueueName,
        label: "AWS SQS Queue Name",
        help: "SQS queue name created for S3 Event Notification.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "awsS3Region",
        onChange,
        fieldData: formData.awsS3Region,
        help: "S3 Bucket region where the log files exists.",
        required: true,
        label: "S3 Region"
      },
      renderOptions(regions, "Choose your account region", false)
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "text",
        id: "assumeRoleArn",
        fieldData: formData.assumeRoleArn,
        label: "AWS Assume Role (ARN)",
        onChange,
        help: "Amazon Resource Name with required cross account permission",
        placeholder: "arn:aws:sts::123456789012:assumed-role/some-role",
        maxLength: 2048
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "text",
        id: "awsExternalId",
        fieldData: formData.awsExternalId,
        label: "AWS External ID",
        onChange,
        help: "External ID for the assume role ARN, used to prevent the confused deputy problem. Only applies when an assume role ARN is provided.",
        placeholder: "External ID",
        maxLength: 2048
      }
    )
  );
};
export default StepAuthorize;
